import React, { Component } from 'react';
import API from "../../config/api";
import moment from 'moment';
import { ToastContainer, toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import Select from 'react-select';
import PopupImage from "../Bar/PopupImage";
import './../custom.css';
import CustomModal from "../Bar/CustomModal";
import ReactQuill from 'react-quill';
import 'react-quill/dist/quill.snow.css';
import { Link, Navigate, useNavigate } from "react-router-dom";

const modules = {
  toolbar: [
    [{ header: '1' }, { header: '2' }, { font: [] }],
    [{ size: [] }],
    [{ color: [] }, { background: [] }],
    ['bold', 'italic', 'underline', 'strike', 'blockquote'],
    [{ align: '' }, { align: 'center' }, { align: 'right' }, { align: 'justify' }],
    [{ list: 'ordered' }, { list: 'bullet' }],
    // ['link', 'image', 'video'],
    ['clean'],
  ],
};

export class TopicEdit extends Component {

    constructor(props) {
        super(props)
      
        this.state = {
          page: 1,
          word_type: [],
          topic_id: null,
          name_khmer: '',
          name_korean: '',
          description: '',
          code: '',
          type: '',
          thumbnail: null,
          limit: 100,
          s: '',
          preview_thumbnail_progress: null,
          full_image_url: '',

          id: 1,
          quizs: [],
          all_categories: [],
          selected_categories: [],
          added_questions: [],

          data: [],
          percentage: 0,
          disable: true,
          // thumbnail: null,
          // image_url: "",
          // description: "",
          success: null,
          category_id: 1,
          categories: [],
          fields: {
            name: "",
            // description: ""
          },
          errors: {},
        }
        this.inputRefs = {
          name: React.createRef(),
          // description: React.createRef(),
        };
      }

      UNSAFE_componentWillMount() {
        this.getParam("id")
        // this.getParam("topic")
        this.getAllWordType();
        this.getImage();
      }

      getParam(name) {
        let id = window.location.search.split(`${name}=`)[1]
        if (name == "id") {
          this.state.id = id;
          this.setState({});
          this.getOneTopic();
        }
        // if (name == "topic") {
        //   this.state.topic_id = id;
        //   this.setState({});
        //   this.getOneTopic();
        // }

        // if (id) {
        //   this.getOneTopic();
        // }
      }
      getAllWordType = async () => {
        try {
          let query = `page=${this.state.page}&s=${this.state.s}&type=${this.state.id}&limit=${this.state.limit}`
          let results = await API.getAllWordType(query);
          let data = results.data;
          
          this.setState({ word_type : data.vocab_folders, total: data.total });
    
        } catch (error) {
          console.log(error)
        }
      }

      getImage() {
        let url = API.getImage();
        this.setState({image_url : url})
      }

      getOneQuestion = async (id) => {
        try {
          let query = `id=${id}`
          let results = await API.getOneQuestion(query);
    
          let data = results.data.quiz;
          this.state.added_questions.push(data)
          this.setState({})
        } catch (error) {
          console.log(error)
        }
      }
    
      getOneTopic = async () => {
        try {
          let query = `id=${this.state.id}`
          let results = await API.getOneTopic(query);
    
          let data = results.data;


          // let questions = [];
          // let get_question = data.vocab;
          // get_question.map(q => {
          //   questions.push(q)
          // })

          // this.setState({ 
          //   added_questions: questions,
          //   data : data, 
          //   code: data.code,
          //   description: data.description,
          //   name: data.name_khmer,
          //   thumbnail: data.thumbnail_url,
          //   full_image_url: data.full_thumbnail_url
          // });


          // this.state.added_questions = questions;
          this.state.data = data;
          this.state.code = data.code;
          this.state.type = data.type;
          this.state.description = data.description;
          this.state.name_khmer = data.name_khmer;
          this.state.name_korean = data.name_korean;
          this.state.fields.name = data.name_khmer;
          this.state.thumbnail = data.thumbnail_url;
          this.state.full_image_url = data.full_thumbnail_url;

          this.setState({});
    
        } catch (error) {
          console.log(error)
        }
      }

      // getAllClass = async () => {
      //   try {
      //     let query = `page=${this.state.page}&s=${this.state.s}&limit=${this.state.limit}`
      //     let results = await API.getAllClass(query);
      //     let data = results.data;
          
      //     this.setState({ quizs : data.class, total: data.total });
    
      //   } catch (error) {
      //     console.log(error)
      //   }
      // }

      onQuestionFourImageChange = async (event) => {
        event.preventDefault();
        let file = event.target.files[0];
        const formData = new FormData();
        formData.append("file", file);
        
        try {
          let results = await API.adminUpload(
            formData,
            (percentage) => {
              this.state.preview_image_progress = percentage;
              this.setState({})
            }
          );
          if (results){
            this.state.preview_image_progress = 100;
            this.state.thumbnail = results.filename;
            this.state.full_image_url = results.full_url;
            this.setState({});
            // this.setState({ image_url: results.filename })
          }
    
        } catch (error) {
          toast.error("Oops! Something went wrong. Please try again.", {
            data: {
              title: "Success toast",
              text: "This is a success message",
            },
          })
          console.log(error)
        }
      }

      getAllWordList = async () => {
        try {
          let query = `page=${this.state.page}&s=${this.state.s}&limit=${this.state.limit}`
          let results = await API.getAllWordList(query);
          let data = results.data;
          
          this.setState({ quizs : data.vocabs, total: data.total });
    
        } catch (error) {
          console.log(error)
        }
      }

      onSearch = async (event) => {
        event.preventDefault();
        let value = event.target.value;
        this.state.s = value;
        this.setState({});
        this.getAllWordType();
      }

      onUploadProgress = (percentage) => {
        this.setState({ percentage: percentage})
        if (percentage ===100) {
          this.setState({ disable: false })
        }
      }

      onChangeFile = async (event) => {
        event.preventDefault();
        let file = event.target.files[0];
        let name = event.target.name;
        const formData = new FormData();
        formData.append("file", file);
        
        try {
          let results = await API.adminUpload(
            formData,
            this.onUploadProgress
          );
          
          if (results){
            this.state.thumbnail = results.filename;
            this.state.full_thumbnail = results.full_url;
            // this.setState({ data: {
            //   ...this.state.data,
            //   [name]: results.filename,
            // }})
          }
    
        } catch (error) {
          console.log(error)
        }
      }

      validateFields = () => {
        const { fields } = this.state;
        const errors = {};
        let firstEmptyField = null;
    
        // Check for empty fields
        Object.keys(fields).forEach((field) => {
          if (!fields[field].trim()) {
            errors[field] = `${field.charAt(0).toUpperCase() + field.slice(1)} is required`;
            if (!firstEmptyField) {
              firstEmptyField = field; // Record the first empty field
            }
          }
        });
    
        this.setState({ errors });
    
        // Focus on the first empty field
        if (firstEmptyField) {
          this.inputRefs[firstEmptyField].current.focus();
        }
    
        // Return true if no errors
        return Object.keys(errors).length === 0;
      }

      // handelInput = (event) => {
      //   event.preventDefault();
      //   let value = event.target.value;
      //   let name = event.target.name;
        
      //   this.setState({ data: {
      //     ...this.state.data,
      //     [name]: value
      //   }})
      // }
      deleteFolder = async (event) => {
        event.preventDefault();
        let data = {
          id : this.state.data.id
        }
        try {
          let results = await API.postDeleteWordType(data);
          
          if (results.result){
            toast.success("Your action is successful", {
              data: {
                title: "Success toast",
                text: "This is a success message",
              },
            })
            this.getAllWordType();
          }
    
        } catch (error) {
          console.log(error)
        }
      }

      handelInput = (event) => {

        const { name, value } = event.target;
        this.setState((prevState) => ({
          fields: {
            ...prevState.fields,
            [name]: value,
          },
          errors: {
            ...prevState.errors,
            [name]: "", // Clear error for the field being updated
          },
        }));
      }
      
      onRemoveQuestion(data){
        this.state.added_questions.splice(this.state.added_questions.indexOf(data), 1);
        // this.state.quizs.push(data)
        // toast.success("Your action is successful", {
        //   data: {
        //     title: "Success toast",
        //     text: "This is a success message",
        //   },
        // })
        this.setState({})
    
      }

      onAddQuestion(data  = {}) {
        data.new = true;
        this.state.added_questions.unshift(data);
        
        // this.state.added_questions.push(data)
        // this.state.quizs.splice(this.state.quizs.indexOf(data), 1)

        // toast.success("Your action is successful", {
        //   data: {
        //     title: "Success toast",
        //     text: "This is a success message",
        //   },
        // })
        this.setState({})
      }
    
      handleSubmit = async (event) => {
        event.preventDefault();
        // if (!this.validateFields()) return

        // let quis_id = [];
        let quiz_id = this.state.added_questions.map(quiz => {
          return quiz.id
        });

         let data = {
          id: this.state.id,
          name_khmer: this.state.name_khmer,
          name_korean: this.state.name_korean,
          description: this.state.description,
          code: this.state.code,
          type: this.state.type,
          thumbnail_url: this.state.thumbnail,
          vocab_id: JSON.stringify(quiz_id)
         }

        // this.state.data.quiz_id = JSON.stringify(quiz_id)
        
        try {
          let results = await API.postOneTopic(data);
          if (results){
            this.state.id = results.data.id;
            this.setState({});
            toast.success("Your action is successful", {
              data: {
                title: "Success toast",
                text: "This is a success message",
              },
            })
            
            
            // this.setState({ success: results.result })
          }
    
        } catch (error) {
          console.log(error)
        }
      }

  render() {
    const { fields, errors } = this.state;
    return (
        <div className="col-12">
          <ToastContainer />
          {this.state.success && (
              <Navigate to="/topicindex" replace={true} />
              // <Navigate to="/topicindex?success=true" replace={true} />
          )}
            <form className="card" onSubmit={this.handleSubmit}>
                <h4 className="card-title"><strong>Topic</strong></h4>

                <div className="card-body row">

                  {/* <div className="col-md-6">
                    <div className="form-group">
                        <label className="require" for="input-required">Name</label>
                        <input type="text" className="form-control" id="input-required" value={this.state.name} name='name' 
                        ref={this.inputRefs.name}
                        style={{
                          border: errors.name ? "1px solid red" : "", 
                        }}
                        onChange={(event) => {
                          this.state.name = event.target.value;
                          this.setState({})
                          this.handelInput(event)
                        }} />
                        {errors.name && <span style={{ color: "red" }}>{errors.name}</span>}
                    </div>
                  </div> */}
                  
                  <div className="col-md-6">
                    <div className="form-group">
                      <label>Name Korean</label>
                      {/* <input className="form-control" type="text" value={this.state.description} name='description' onChange={(event) => {
                        this.state.description = event.target.value;
                        this.setState({})
                      }} /> */}
                      <ReactQuill 
                      theme="snow" 
                      modules={modules}
                      style={{"height" : "150px", marginTop: 10}} 
                      value={this.state.name_korean} 
                      onChange={(value) => {
                        this.state.name_korean = value;
                        this.setState({})
                      }}  
                      />
                      <br /><br />
                      <br />
                    </div>
                  </div>
                  <div className="col-md-6">
                    <div className="form-group">
                      <label>Name Khmer</label>
                      {/* <input className="form-control" type="text" value={this.state.description} name='description' onChange={(event) => {
                        this.state.description = event.target.value;
                        this.setState({})
                      }} /> */}
                      <ReactQuill 
                      theme="snow" 
                      modules={modules}
                      style={{"height" : "150px", marginTop: 10}} 
                      value={this.state.name_khmer} 
                      onChange={(value) => {
                        this.state.name_khmer = value;
                        this.setState({})
                      }}  
                      />
                      <br /><br />
                    </div>
                  </div>


                    <div className="col-md-6">
                      <div className="form-group">
                        <label>Description</label>
                        <input className="form-control" type="text" value={this.state.description} name='description' onChange={(event) => {
                          this.state.description = event.target.value;
                          this.setState({})
                        }} />
                      </div>
                    </div>
                    {/* <div className="col-md-6">
                      <div className="form-group">
                        <label>Code</label>
                        <input className="form-control" type="text" value={this.state.code} name='code' onChange={(event) => {
                          this.state.code = event.target.value;
                          this.setState({})
                        }} />
                      </div>
                    </div> */}
                    
                    {/* <div className='col-md-6'>
                      <div className="form-group">
                        <label >Type</label>
                        <select id="inputState" className="form-control" value={this.state.type} name="level"
                            
                            onChange={(event) => {
                              this.state.type = event.target.value;
                              this.setState({})
                            }}>
                            <option value={0}>Please select type</option>
                            <option value="vocab">Vocabulary</option>
                            <option value="verb">Verb</option>
                            <option value="grammar">Grammar</option>
                        </select>
                      </div>
                    </div>
                    <div className='col-md-6'></div> */}
                    
                    {/* <div className='col-md-6'>
                      <div className="form-group">
                        <label >Image</label> &emsp;
                        <div style={{
                            marginTop: '10px',
                            textAlign: 'center', 
                            // MaxHeight: '50px',
                            height: this.state.full_image_url ? '250px' : 0,
                            // objectFit: 'cover'
                            display: 'flex', // Flexbox for alignment
                            justifyContent: 'center', 
                            alignItems: 'center', 
                            }}>
                        {
                          this.state.full_image_url && <PopupImage
                          thumbnailUrl={this.state.full_image_url} 
                          imageUrl={this.state.full_image_url} 
                        />
                        }
                      </div>
                        <input type="file" accept="image/*" data-provide="dropify" onChange={(e) => this.onQuestionFourImageChange(e)} /> 
                        <div class="progress">
                          <div class="progress-bar" role="progressbar" style={{width: this.state.preview_thumbnail_progress + "%", height: "10px"}} aria-valuenow="25" aria-valuemin="0" aria-valuemax="100"><strong>{this.state.preview_thumbnail_progress ? this.state.preview_thumbnail_progress + "%" : null}</strong></div>
                        </div>  
                      </div> 
                    </div> */}


                    

                    
                </div>



                {/* add questions */}
                <footer className="card-footer text-right">
                    <Link className="btn btn-secondary" to="/topicindex">Back</Link>
                    <button className="btn btn-primary" type="submit">Submit</button>
                </footer>
                
                

                {/* {
                  this.state.id && <div>
                    <h4 className="card-title"><strong>Word Type</strong></h4>
                      <div className="card-body row">

                          <div className="col-md-12">



                          <div className="card-body">

                        <div className="flexbox mb-20">
                            <div className="lookup">
                              <input className="w-200px" type="text" name="s" placeholder="Search" onChange={this.onSearch} />
                            </div>

                            <div className="btn-toolbar">
                              <div className="btn-group btn-group-sm">
                              

                                <Link to={`/wordtypeedit?topic=${this.state.id}`} > <button className="btn btn-primary" title="Add new" data-provide="tooltip"> <i className="ion-plus-round"></i></button></Link>
                              </div>

                             
                              </div>
                            </div>
                          <div>
                        </div>
                      </div>

                      <div className="table-container" >
                            <table className="fixed-header-table">

                              <thead>
                                <tr>
                                  <th>#</th>
                                  <th className="text-center w-150px">Name korean</th>
                                  <th className="text-center w-150px">Name Khmer</th>
                                  <th className="text-center ">Description</th>
                                  <th className="text-center w-150px">Actions</th>
                                </tr>
                              </thead>
                              <tbody>
                              {
                                this.state.word_type && this.state.word_type.map((type, index)=> {
                                 

                                  return <tr>
                                    <th scope="row">{( (this.state.page - 1) * 10) + (index+ 1)} </th>
                                    
                                    <td style={{paddingTop: 20}}><strong dangerouslySetInnerHTML={{ __html: type.name_korean }}></strong></td>
                                    <td style={{paddingTop: 20}}><strong dangerouslySetInnerHTML={{ __html: type.name_khmer }}></strong></td>
                                    <td><strong>{type.description}</strong></td>
                                    <td className="text-center table-actions">
                                      <Link title='View' class="btn btn-square btn-round btn-primary" to={`/wordtypeedit?id=${type.id}`}><i class="fa fa-eye"></i></Link>
                                      <span>&nbsp;</span><Link title='Edit' class="btn btn-square btn-round btn-info" to={`/wordtypeedit?id=${type.id}`}><i class="ti-pencil"></i></Link>
                                      <span>&nbsp;</span><Link title='Delete' class="btn btn-square btn-round btn-danger"><i data-toggle="modal" data-target="#modal-center" onClick={() => this.setState({data: type})} class="fa fa-trash"></i></Link>
                                    
                                    </td>
                                  </tr>
                                  
                                })
                              }
                              </tbody>
                            </table>
                          </div>
                          </div>
                      </div>    
                  </div>
                } */}


                
            </form>
            {
              this.state.data &&
              <CustomModal 
                data={ this.state.data }  
                title="Do you really want to delete this type?"
                deleteQuiz = {this.deleteFolder}
              />
           }
        </div>
    )
  }
}

const MyComponentWithNavigate = () => {
  const navigate = useNavigate();
  return <TopicEdit navigate={navigate} />;
};

export default MyComponentWithNavigate